const ANNOUNCEMENTS = [
  '📚 Discover Your Next Favorite Book',
  '🎁 Refer & Earn 10 Credits',
  '⚡ Instant Digital Access After Purchase',
  '🚚 No Physical Copy — Digital Product Only',
  '🔒 Secure & Easy Payment',
  '📖 Read Your Books Anytime, Anywhere',
];

function AnnouncementTrack({ ariaHidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden || undefined}>
      {ANNOUNCEMENTS.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap px-4 sm:px-6">
          <span className="text-xs sm:text-sm font-medium tracking-wide text-white">
            {item}
          </span>
          <span className="ml-4 sm:ml-6 text-white/50" aria-hidden="true">•</span>
        </span>
      ))}
    </div>
  );
}

export default function AnnouncementBar() {
  const message = ANNOUNCEMENTS.join(' • ');

  return (
    <div
      role="region"
      aria-label={message}
      className="flex group relative isolate overflow-hidden bg-gradient-to-r from-primary-600 to-accent-600 dark:from-primary-400 dark:to-accent-400"
    >
      <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused] motion-reduce:animate-none">
        <AnnouncementTrack />
        <AnnouncementTrack ariaHidden />
      </div>
    </div>
  );
}
